// Resolve a Formik error for a dotted/bracketed path such as
// "meta.lease_holders[0].name" against the `errors` and `touched` trees.
// Returns the message only when the field is touched and the error is a
// string (an object means "errors live deeper"). A list-level path such as
// "meta.lease_holders" resolves the same way, so Yup `.max` messages surface.
export const splitFormPath = (path) =>
  String(path || "")
    .split(/[.[\]]+/)
    .filter((part) => part !== "");

export const nestedFormError = (errors, touched, path) => {
  const parts = splitFormPath(path);
  if (parts.length === 0) return null;
  const touchedValue = parts.reduce((obj, key) => obj?.[key], touched);
  const errorValue = parts.reduce((obj, key) => obj?.[key], errors);
  if (touchedValue && typeof errorValue === "string") return errorValue;
  return null;
};
